import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Button,
  ButtonsWrapper,
  ICONS,
  Loader,
  PLATFORM_THEME_COLORS,
  Typography,
  TYPOGRAPHY_SIZE,
} from '@thinknet-gmbh/platform-common-ui';
import { PERMISSION_ACTIONS, PLATFORM_PERMISSIONS } from '@thinknet-gmbh/platform-common';

import { useRouteQuery } from 'src/common/helpers';
import PermissionCheck from 'src/components/permission-check';
import { useGetAppraisalInterviewById } from 'src/hooks/appraisal-interview/get-appraisal-interview-by-id.hook';

import { MainContainer } from './employee-interview-details.styles';
import { EmployeeInterviewDetailsView } from './components/employee-interview-details-view';
import { EmployeeInterviewDetailsEdit } from './components/employee-interview-details-edit';

const EmployeeInterviewDetails = () => {
  const { t } = useTranslation(['employee', 'common']);
  const [isEdit, setIsEdit] = useState(false);
  const [isAddedInterview, setIsAddedInterview] = useState(false);
  const query = useRouteQuery();
  const id = query.get('appraisalInterviewId') || '';

  const { appraisalInterview, loading } = useGetAppraisalInterviewById(id);

  useEffect(() => {
    setIsAddedInterview(false);
  }, [isAddedInterview]);

  if (loading) {
    return <Loader />;
  }

  return (
    <MainContainer>
      <div>
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
          {t('employee:labels.employeeInterview')}
        </Typography>
        <ButtonsWrapper>
          {isEdit && (
            <Button
              type="primary"
              ghost
              icon={ICONS.plus}
              iconColor={PLATFORM_THEME_COLORS.primary.blue}
              onClick={() => setIsAddedInterview(true)}
            >
              {t('employee:employeeInterview.buttons.addNewInterview')}
            </Button>
          )}
          {!isEdit && (
            <PermissionCheck
              permission={PLATFORM_PERMISSIONS.memberManagement}
              action={PERMISSION_ACTIONS.create}
            >
              <Button
                type="primary"
                ghost
                icon={ICONS.editAlt}
                iconColor={PLATFORM_THEME_COLORS.primary.blue}
                onClick={() => setIsEdit(true)}
              >
                {t('common:buttons.edit')}
              </Button>
            </PermissionCheck>
          )}
        </ButtonsWrapper>
      </div>
      {isEdit ? (
        <EmployeeInterviewDetailsEdit
          data={appraisalInterview}
          onClose={() => setIsEdit(false)}
          isAddedInterview={isAddedInterview}
        />
      ) : (
        <EmployeeInterviewDetailsView data={appraisalInterview} />
      )}
    </MainContainer>
  );
};

export default EmployeeInterviewDetails;
